/** @format */

import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import CardWrap from "../../Common/CardWrap";
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";
import iconcontentcalendar from "../../../Images/Icons/iconcontentcalendar.png";
import Select from "react-select";
import DatePicker, { registerLocale } from "react-datepicker";
import { GlobalContext } from "../../../Contexts/GlobalContextProvider";
import { AuthContext } from "../../../Contexts/AuthContext";
import { globalServices } from "../../../Services/global.service";
import { initialStateService } from "../../../Services/AccountingServices/initialState.service";
import { storeService } from "../../../Services/store.service";
import ResultModal from "../../Common/ResultModal";
import AddProductModal from "../../Common/AddProductModal";
import hr from "date-fns/locale/hr";
import en from "date-fns/locale/en-US";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import cellEditFactory from "react-bootstrap-table2-editor";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import AsyncSelect from "react-select/async";
import ProductsFilterModal from "../../Common/ProductsFilterModal";
import { numbersAndDot } from "../../../Config/Regex";
import { roles } from "../../../Config/Roles";
import XLSX from "xlsx";
import CsvImport from "../../Common/CsvImport";
import { Dropdown, Modal } from "react-bootstrap";

registerLocale("hr", hr);
registerLocale("en", en);

const DocumentCreate = () => {
  const { selectedLanguageId, isMobile } = useContext(GlobalContext);
  const { userId, useAccounting, roleId } = useContext(AuthContext);
  const { t: translator } = useTranslation();
  const history = useHistory();
  const {
    register,
    handleSubmit,
    errors,
    control,
    formState,
    setValue,
    getValues,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const [showFilterModal, setShowFilterModal] = useState(false);
  const [stores, setStores] = useState([]);
  const [products, setProducts] = useState([]);
  const [loadModal, setLoadModal] = useState(false);
  const [values, setValues] = useState({
    storeId: 0,
    tenantId: 0,
    priceListId: 0,
  });
  const [showProductModal, setShowProductModal] = useState(false);
  const [modalValidationMsg, setModalValidationMsg] = useState("");
  const [quantityMsg, setQuantityMsg] = useState("");
  const [showImportModal, setShowImportModal] = useState(false);

  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });

  const addFilterProducts = (filterProducts) => {
    let newArr = [...products];

    //svi koji su bili izbrisani u state isActive false
    let oldDeleted = newArr.filter((ar) =>
      products.find(
        (rm) => rm.productGuid === ar.productGuid && ar.isActive === false,
      ),
    );

    //vraćam ih na isActive true
    oldDeleted.forEach((el) => (el.isActive = true));

    //ukloniti treci niz iz statea
    newArr = newArr.filter(
      (ar) => !oldDeleted.find((rm) => rm.productGuid === ar.productGuid),
    );

    //vraćamo stare kao isActive true
    newArr = newArr.concat(oldDeleted);

    let addedProducts = filterProducts.filter(
      (item) => !newArr.find((rm) => rm.productGuid === item.productGuid),
    );
    console.log("addedProducts", addedProducts);

    let newProducts = addedProducts.map((prod) => ({
      productGuid: prod.productGuid,
      productName: prod.productName,
      price: 0,
      price2: prod.price2,
      quantity: Number(prod.quantity),
      unitMeasureName: prod.unitMeasureName,
      tax: prod.tax,
    }));

    newArr = newArr.concat(newProducts);
    setProducts(newArr);
  };

  const addNewProduct = (productGuid, productName, price) => {
    setProducts([
      ...products,
      { productGuid, productName, price, quantity: 0 },
    ]);
  };

  const onSubmit = (data) => {
    console.log("DATA ", data.date);
    
    let formatedDate = new Date(
      new Date(data.date).getTime() + 8 * 60 * 60 * 1000,
    );

    if (
      products.some(
        (e) => e.quantity === null || e.quantity === 0 || e.quantity < 0,
      )
    ) {
      setQuantityMsg("QuantityNotNullAndNotNegative");
      return false;
    }

    if (products.some((e) => e.quantity >= 10000000)) {
      setQuantityMsg("QuantityMaxThousand");
      return false;
    }

    initialStateService
      .documentCreate(data.date, data.storeId.id, data.note, products)
      .then((res) => {
        if (res.data.success) {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-CreateSuccess-Title",
            text: "InitialState-ResultModal-CreateSuccess-Text",
            show: true,
            btnClass: "btn btn-primary",
            success: true,
          });
        } else {
          setModal({
            ...modal,
            title: "InitialState-ResultModal-CreateError-Title",
            text: translator(res.data.message),
            show: true,
            btnClass: "btn btn-primary",
            success: false,
          });
        }
      })
      .catch((err) => console.log(err));
  };

  const handleCancel = () => {
    history.goBack();
  };

  const handleClose = () => {
    setModal({ ...modal, show: false });
    if (modal.success === true) {
      history.push("/initial-state");
    }
  };

  useEffect(() => {
    if (!useAccounting) history.push("/error-page/401");
  }, []);

  const promiseOptions = (inputValue) => {
    return globalServices
      .getTenantsRobno(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        inputValue,
      )
      .then((res) => {
        var result = res.data.map((e) => ({
          id: e.id,
          label: e.name,
          value: e.id,
        }));

        if (Number(roleId) === roles.owner && result.length === 1) {
          const tenantId =
            Number(localStorage.getItem("tenantId")) > 0
              ? Number(localStorage.getItem("tenantId"))
              : 0;
          const tenant = result.find((x) => x.id === tenantId) || null;
          setValue("tenantId", tenant);
          handleOnChangeTenantId(tenant ? [tenant] : null);
        }

        result.unshift({
          id: 0,
          label: translator("SelectTenant-Choose"),
          value: 0,
        });
        return result;
      })
      .catch((err) => err);
  };

  function actionFormatter(cell, row) {
    return (
      <div className="action">
        <span className="icon icon-cancel" style={{ color: "#c00" }}></span>
      </div>
    );
  }

  const options = {
    sizePerPage: 10,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };

  const { SearchBar } = Search;
  function currencyFormatter(cell) {
    return new Intl.NumberFormat("hr", {
      style: "currency",
      currency: "EUR",
    }).format(Number(cell));
  }
  function nameFormatter(cell, row) {
    return row.isRawMaterial ? cell + "(Sirovina)" : cell;
  }
  const columns = [
    {
      dataField: "productGuid",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      formatter: actionFormatter,
      searchable: false,
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          setProducts(
            products.filter((item) => item.productGuid !== row.productGuid),
          );
        },
      },
    },
    {
      dataField: "productName",
      text: translator("InitialState-Product"),
      formatter: nameFormatter,
      editable: false,
    },
    {
      dataField: "unitMeasureName",
      text: translator("InitialState-UnitOfMeasure"),
      editable: false,
      searchable: false,
    },
    {
      dataField: "price",
      text: translator("Nabavna cijena") ,
      formatter: currencyFormatter,
      // editable: false,
      searchable: false,
    },
    {
      dataField: "margin",
      text: `${translator("InitialState-Margin")}*`,
      searchable: false,
      formatter: (cell) => (cell || 0) + "%",
      validator: (newValue, row, column) => {
        if (isNaN(newValue) || newValue == "") {
          return {
            valid: false,
            message: translator("PriceNumberMsgTable"),
          };
        }
        // setIsDisabled(false);
        return true;
      },
    },
    {
      dataField: "tax",
      text: `${translator("InitialState-Tax")}`,
      editable: false,
      formatter: (cell) => (cell || 0) + "%",
    },
    {
      dataField: "price2",
      text: `${translator("InitialState-Price")}*`,
      formatter: currencyFormatter,
      // editable: initValue.documentNumber ? false : true,
      searchable: false,
      validator: (newValue, row, column) => {
        if (isNaN(newValue) || newValue == "") {
          return {
            valid: false,
            message: translator("PriceNumberMsgTable"),
          };
        }
        if (newValue < 0) {
          return {
            valid: false,
            message: translator("PriceNotNegativeMsg"),
          };
        }

        if (newValue >= 100000) {
          return {
            valid: false,
            message: translator("PriceMaxMsg"),
          };
        }

        return true;
      },
    },
    {
      dataField: "quantity",
      text: `${translator("InitialState-Quantity")}*`,
      searchable: false,
      validator: (newValue, row, column) => {
        if (
          isNaN(newValue) ||
          newValue == "" ||
          !numbersAndDot.test(newValue)
        ) {
          return {
            valid: false,
            message: translator("QuantityNumberMsg"),
          };
        }
        if (newValue < 0) {
          return {
            valid: false,
            message: translator("QuantityNotNegative"),
          };
        }

        if (newValue >= 100000) {
          return {
            valid: false,
            message: translator("QuantityMaxThousand"),
          };
        }
        setQuantityMsg("");
        return true;
      },
    },
  ];

  const handleOnChangeTenantId = (event) => {
    if (!event) return;
    setValue("storeId", null, {
      shouldValidate: true,
    });
    globalServices
      .getStoresByTenantId(event[0].id)
      .then((res) => {
        setStores(res.data);
        setProducts([]);
      })
      .catch((err) => console.log(err));
    return event[0];
  };

  const EXCEL_HEADING = {
    documentDetailGuid: "documentDetailGuid",
    productGuid: "productGuid",
    groupName: translator("InitialState-GroupName"),
    productName: translator("InitialState-Product"),
    unitMeasureName: translator("InitialState-UnitOfMeasure"),
    price: translator("Nabavna cijena"),
    margin: translator("InitialState-Margin"),
    tax: translator("InitialState-Tax"),
    price2: translator("InitialState-Price"),
    quantity: translator("InitialState-Quantity"),
  };

  const handleExport = () => {
    const formValues = getValues();
    var ws_name = `${formValues?.tenantId?.label || ""}_${formValues?.storeId?.label || ""}_${translator("InitialState-Items")}.xlsx`;
    // New work book
    var wb = XLSX.utils.book_new();
    // Constant Data
    var ws_data = [
      [
        EXCEL_HEADING.documentDetailGuid,
        EXCEL_HEADING.productGuid,
        EXCEL_HEADING.groupName,
        EXCEL_HEADING.productName,
        EXCEL_HEADING.unitMeasureName,
        EXCEL_HEADING.price,
        EXCEL_HEADING.margin,
        EXCEL_HEADING.tax,
        EXCEL_HEADING.price2,
        EXCEL_HEADING.quantity,
      ],
    ];
    // Inconsistent data / Reports
    const ws_sufix = products.map((x) => {
      const array = [
        x.documentDetailGuid,
        x.productGuid,
        x.groupName,
        x.productName,
        x.unitMeasureName,
        Number(x.price) || 0,
        Number(x.margin) || 0,
        Number(x.tax) || 0,
        Number(x.price2) || 0,
        x.quantity,
      ];
      return array;
    });
    // Merge data
    ws_data = [...ws_data, ...ws_sufix];
    // Export to xlsx
    const ws = XLSX.utils.aoa_to_sheet(ws_data);
    ws["!cols"] = [
      { width: 40 },
      { width: 40 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];
    XLSX.utils.book_append_sheet(wb, ws, "Primka");
    XLSX.writeFile(wb, ws_name);
  };

  return (
    <>
      <CardWrap subtitle={translator("InitialState-DocumentCreate")}>
        <form onSubmit={handleSubmit(onSubmit)} className="row">
          <div className="col-lg-4">
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                {translator("InitialState-IndexData")}
              </legend>
              <div className="form-group">
                <div className="form-group">
                  <label>{translator("InitialState-Date")}</label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text" id="basic-addon1">
                        <img src={iconcontentcalendar} alt="calendar" />
                      </span>
                    </div>
                    <Controller
                      as={DatePicker}
                      control={control}
                      autoComplete="off"
                      className="form-control"
                      dateFormat="dd.MM.yyyy"
                      name="date"
                      showYearDropdown={true}
                      rules={{ required: true }}
                      locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                      valueName="selected"
                      defaultValue={new Date()}
                      onChange={([selected]) => selected}
                      minDate={new Date()}
                    />
                    {errors.date && errors.date.type === "required" && (
                      <p className="col-md-10 pl-0 text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                  </div>
                </div>
                <div className="form-group">
                  <label>{translator("EditPOS-Tenant")}</label>{" "}
                  <Controller
                    as={AsyncSelect}
                    control={control}
                    name="tenantId"
                    onChange={handleOnChangeTenantId}
                    placeholder={translator("Select-Tenant")}
                    defaultOptions={true}
                    loadOptions={promiseOptions}
                    rules={{
                      validate: function (value) {
                        if (!value) return false;
                        return value.value === 0 ? false : true;
                      },
                    }}
                  />
                  {errors.tenantId && errors.tenantId.type === "validate" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                </div>
                <div className="form-group">
                  <label>{translator("InitialState-Store")}</label>
                  <Controller
                    as={Select}
                    options={
                      stores &&
                      stores.map((p) => ({
                        id: p.id,
                        label: p.name,
                        value: p.id,
                      }))
                    }
                    name="storeId"
                    placeholder={translator("Select-Store")}
                    rules={{
                      validate: function (value) {
                        if (!value) return false;
                        return value.value === null ? false : true;
                      },
                    }}
                    control={control}
                    onChange={function (event) {
                      setModalValidationMsg("");
                      globalServices
                        .getFilterProducts(event[0].id, 1)
                        .then((res) => setProducts(res.data.data))
                        .catch((err) => console.log(err));

                      storeService
                        .getById(event[0].id)
                        .then((res) => {
                          setValues({
                            storeId: event[0].id,
                            tenantId: res.data.tenantId,
                            priceListId: res.data.priceListId,
                          });
                          setLoadModal(true);
                        })
                        .catch((err) => console.log(err));

                      return event[0];
                    }}
                  />
                  {errors.storeId && errors.storeId.type === "validate" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                </div>
                <div className="form-group">
                  <label>{translator("InitialState-Note")}</label>
                  <textarea
                    name="note"
                    ref={register({ maxLength: 250 })}
                    className="form-control"
                    rows={4}
                    id="textArea"
                  ></textarea>
                  {errors.note && errors.note.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength250")}
                    </p>
                  )}
                </div>
              </div>
            </fieldset>
          </div>
          <div className="col-lg-8">
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                {translator("InitialState-Items")}
              </legend>

              <div className="form-group">
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    if (document.getElementsByName("storeId")[0].value === "") {
                      setModalValidationMsg("ValidationMsg-SelectStore");
                    } else setShowFilterModal(true);
                  }}
                >
                  <span className="icon icon-filter"></span>{" "}
                  {translator("Filter")}
                </button>
                &nbsp;
                <Dropdown className="ml-2 float-right">
                  <Dropdown.Toggle
                    variant="outline-secondary"
                    id="dropdown-basic"
                  >
                   
                    <span className="mob-hidden">
                      {translator("ListAdminButtons-Dropdown-Import-Export")}
                    </span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => setShowImportModal(true)}>
                      <span className="">
                        {isMobile
                          ? translator(
                              "ListAdminButtons-Dropdown-BulkImport-Mobile",
                            )
                          : translator("ListAdminButtons-Dropdown-BulkImport")}
                      </span>
                    </Dropdown.Item>
                    <Dropdown.Item onClick={handleExport}>
                      <span className="">
                        {isMobile
                          ? translator(
                              "ListAdminButtons-Dropdown-DataExport-Mobile",
                            )
                          : translator("ListAdminButtons-Dropdown-DataExport")}
                      </span>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <span className="text-danger ml-2">
                  {translator(modalValidationMsg)}
                </span>
              </div>

              <div className="mb-3">
                <Modal
                  show={showImportModal}
                  onHide={() => setShowImportModal(false)}
                >
                  <CsvImport
                    setResult={(data) => {
                      let newProducts = data?.data?.map((prod) => ({
                        documentDetailGuid:
                          prod[EXCEL_HEADING.documentDetailGuid],
                        productGuid: prod[EXCEL_HEADING.productGuid],
                        groupName: prod[EXCEL_HEADING.groupName],
                        productName: prod[EXCEL_HEADING.productName],
                        unitMeasureName: prod[EXCEL_HEADING.unitMeasureName],
                        price: Number(prod[EXCEL_HEADING.price]) || 0,
                        margin: Number(prod[EXCEL_HEADING.margin]) || 0,
                        tax: Number(prod[EXCEL_HEADING.tax]) || 0,
                        price2: Number(prod[EXCEL_HEADING.price2]) || 0,
                        quantity: Number(prod[EXCEL_HEADING.quantity]) || 0,
                      }));
                      setProducts(newProducts);
                      setShowImportModal(false);
                    }}
                  />
                </Modal>
              </div>

              <ToolkitProvider
                keyField="productGuid"
                data={products}
                columns={columns}
                search
              >
                {(props) => (
                  <>
                    <div className="form-group">
                      <SearchBar
                        {...props.searchProps}
                        placeholder={translator("Search")}
                        className="col-md-12"
                      />
                    </div>

                    <hr />
                    <span className="text-danger">
                      {translator(quantityMsg)}
                    </span>
                    <BootstrapTable
                      {...props.baseProps}
                      noDataIndication={translator("No-Data")}
                      pagination={paginationFactory(options)}
                      cellEdit={cellEditFactory({
                        mode: "click",
                        blurToSave: true,
                        afterSaveCell: (oldValue, newValue, row, column) => {
                          if (column.dataField == "price") {
                            row.price = newValue;
                            let netPrice =
                              row.price2 / (1 + (row.tax ? row.tax / 100 : 0));

                            row.margin = +Number(
                              ((netPrice - newValue) / newValue) * 100,
                            ).toFixed(4);
                          }
                          if (column.dataField == "margin") {
                            row.price2 =
                              Number(row.price) *
                              (1 + +newValue / 100) *
                              (1 + (row.tax ? +row.tax / 100 : 0));
                            row.margin = +newValue;
                          }
                          if (column.dataField == "price2") {
                            row.price2 = +newValue || 0;
                            let netPrice =
                              newValue / (1 + (row.tax ? row.tax / 100 : 0));

                            row.margin = +Number(
                              ((netPrice - (row.price || 0)) /
                                (row.price || 0)) *
                                100,
                            ).toFixed(4);
                          }
                        },
                      })}
                    />
                    <p>
                      <span className="editableColumns">*</span>
                      {translator("EditableTableColumns")}
                    </p>
                  </>
                )}
              </ToolkitProvider>
            </fieldset>
          </div>
          <div
            className="container-fluid mt-4"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <button
              className="btn btn-outline-secondary"
              type="button"
              onClick={handleCancel}
            >
              {translator("POS-New_EditPOS-Close")}
            </button>
            &nbsp;
            <button
              className="btn btn-primary"
              disabled={!formState.dirty}
              type="submit"
            >
              {translator("POS-New_EditPOS-Save")}
            </button>
          </div>
        </form>
      </CardWrap>
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
      {loadModal && (
        <ProductsFilterModal
          show={showFilterModal}
          storeId={values.storeId}
          prodList={products}
          documentOption={1}
          handleHide={() => setShowFilterModal(false)}
          confirmAdd={addFilterProducts}
        />
      )}
      {loadModal && (
        <AddProductModal
          show={showProductModal}
          tenantId={values.tenantId}
          priceListId={values.priceListId}
          addNewProduct={addNewProduct}
          handleHide={() => setShowProductModal(false)}
        />
      )}
    </>
  );
};

export default DocumentCreate;
